import React from 'react';

import '../style/components/loader.css';

export default function NeoLoader({ className='wave-loader' }) {
    return (
        <div id={className}>
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
        </div>
    );
}

export function StandaloneLoader({ className='neo-standalone-loader' }) {
	return (
		<div className={className}>
			<NeoLoader className="wave"/>
		</div>
	);
}
